"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFailed = void 0;

//上传失败
var uploadFailed = function uploadFailed(msg) {
  document.getElementsByClassName("process_cke")[0].innerText = msg;
};

exports.uploadFailed = uploadFailed;